var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47754 11.9154C9.82772 12.3836 10.2745 12.7709 10.7875 13.0512C11.3006 13.3316 11.8679 13.4982 12.4511 13.54C13.0342 13.5818 13.6195 13.4976 14.1673 13.2933C14.7151 13.089 15.2125 12.7692 15.6258 12.3557L18.072 9.90949C18.8147 9.14054 19.2257 8.11066 19.2164 7.04166C19.2071 5.97266 18.7783 4.95008 18.0224 4.19415C17.2665 3.43823 16.2439 3.00944 15.1749 3.00015C14.1059 2.99086 13.076 3.40181 12.307 4.14449L10.9045 5.53885",
    stroke: "#04B7EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.739 10.2846C12.3888 9.81644 11.942 9.42908 11.429 9.14877C10.9159 8.86846 10.3486 8.70178 9.76545 8.66001C9.18231 8.61825 8.59701 8.70239 8.04924 8.90672C7.50148 9.11105 7.00407 9.4308 6.59074 9.84427L4.14449 12.2905C3.40181 13.0595 2.99086 14.0894 3.00015 15.1584C3.00944 16.2274 3.43823 17.2499 4.19415 18.0059C4.95008 18.7618 5.97266 19.1906 7.04166 19.1999C8.11066 19.2092 9.14054 18.7982 9.90949 18.0555L11.3039 16.6612",
    stroke: "#04B7EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/CopyLinkIcon.ac9c38cec24d9b4bf178d54d0000cf25.svg";
export { ForwardRef as ReactComponent };